export default {
  ChecklistView: 'ChecklistView',
};
